import { render, staticRenderFns } from "./LiveAssignmentOrderList.vue?vue&type=template&id=3128655b&scoped=true"
import script from "./LiveAssignmentOrderList.vue?vue&type=script&lang=js"
export * from "./LiveAssignmentOrderList.vue?vue&type=script&lang=js"
import style0 from "./LiveAssignmentOrderList.vue?vue&type=style&index=0&id=3128655b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3128655b",
  null
  
)

export default component.exports